import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const PermissionContext = createContext(null);
const FUNCTIONALLY_DEPRECATED_PERMISSIONS = new Set(["eval.edit_published"]);

export function PermissionProvider({ children }) {
  const { user } = useAuth();
  const [perms, setPerms] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user.role === "STUDENT") {
      setPerms({});
      setLoaded(true);
      return;
    }
    try {
      const { data } = await api.get("/permissions/me");
      setPerms(data.permissions || {});
    } catch {
      setPerms({});
    } finally {
      setLoaded(true);
    }
  }, [user]);

  useEffect(() => {
    setLoaded(false);
    refresh();
  }, [refresh]);

  const isMaster = user?.role === "MASTER";
  const can = useCallback((key) => {
    if (FUNCTIONALLY_DEPRECATED_PERMISSIONS.has(key)) return false;
    return isMaster || !!perms[key];
  }, [isMaster, perms]);

  return (
    <PermissionContext.Provider value={{ perms, can, loaded, refresh, isMaster }}>
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionContext);
}
